/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SkillsRouteImport } from './routes/skills'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as MeRouteImport } from './routes/me'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LexiconRouteImport } from './routes/lexicon'
import { Route as HomeRouteImport } from './routes/home'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as ConstructionsRouteImport } from './routes/constructions'
import { Route as BrowseRouteImport } from './routes/browse'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PracticeExerciseIdRouteImport } from './routes/practice.$exerciseId'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as ProgressSkillSkillCodeRouteImport } from './routes/progress.skill.$skillCode'
import { Route as ProgressExerciseExerciseIdRouteImport } from './routes/progress.exercise.$exerciseId'

const SkillsRoute = SkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressRoute = ProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeRoute = PracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LexiconRoute = LexiconRouteImport.update({
  id: '/lexicon',
  path: '/lexicon',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const ConstructionsRoute = ConstructionsRouteImport.update({
  id: '/constructions',
  path: '/constructions',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowseRoute = BrowseRouteImport.update({
  id: '/browse',
  path: '/browse',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeExerciseIdRoute = PracticeExerciseIdRouteImport.update({
  id: '/$exerciseId',
  path: '/$exerciseId',
  getParentRoute: () => PracticeRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressSkillSkillCodeRoute = ProgressSkillSkillCodeRouteImport.update({
  id: '/skill/$skillCode',
  path: '/skill/$skillCode',
  getParentRoute: () => ProgressRoute,
} as any)
const ProgressExerciseExerciseIdRoute =
  ProgressExerciseExerciseIdRouteImport.update({
    id: '/exercise/$exerciseId',
    path: '/exercise/$exerciseId',
    getParentRoute: () => ProgressRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/browse': typeof BrowseRoute
  '/constructions': typeof ConstructionsRoute
  '/history': typeof HistoryRoute
  '/home': typeof HomeRoute
  '/lexicon': typeof LexiconRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/practice': typeof PracticeRouteWithChildren
  '/progress': typeof ProgressRouteWithChildren
  '/skills': typeof SkillsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/users': typeof AdminUsersRoute
  '/practice/$exerciseId': typeof PracticeExerciseIdRoute
  '/progress/exercise/$exerciseId': typeof ProgressExerciseExerciseIdRoute
  '/progress/skill/$skillCode': typeof ProgressSkillSkillCodeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/browse': typeof BrowseRoute
  '/constructions': typeof ConstructionsRoute
  '/history': typeof HistoryRoute
  '/home': typeof HomeRoute
  '/lexicon': typeof LexiconRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/practice': typeof PracticeRouteWithChildren
  '/progress': typeof ProgressRouteWithChildren
  '/skills': typeof SkillsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/users': typeof AdminUsersRoute
  '/practice/$exerciseId': typeof PracticeExerciseIdRoute
  '/progress/exercise/$exerciseId': typeof ProgressExerciseExerciseIdRoute
  '/progress/skill/$skillCode': typeof ProgressSkillSkillCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/browse': typeof BrowseRoute
  '/constructions': typeof ConstructionsRoute
  '/history': typeof HistoryRoute
  '/home': typeof HomeRoute
  '/lexicon': typeof LexiconRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/practice': typeof PracticeRouteWithChildren
  '/progress': typeof ProgressRouteWithChildren
  '/skills': typeof SkillsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/users': typeof AdminUsersRoute
  '/practice/$exerciseId': typeof PracticeExerciseIdRoute
  '/progress/exercise/$exerciseId': typeof ProgressExerciseExerciseIdRoute
  '/progress/skill/$skillCode': typeof ProgressSkillSkillCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/browse'
    | '/constructions'
    | '/history'
    | '/home'
    | '/lexicon'
    | '/login'
    | '/me'
    | '/practice'
    | '/progress'
    | '/skills'
    | '/admin/reports'
    | '/admin/users'
    | '/practice/$exerciseId'
    | '/progress/exercise/$exerciseId'
    | '/progress/skill/$skillCode'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/browse'
    | '/constructions'
    | '/history'
    | '/home'
    | '/lexicon'
    | '/login'
    | '/me'
    | '/practice'
    | '/progress'
    | '/skills'
    | '/admin/reports'
    | '/admin/users'
    | '/practice/$exerciseId'
    | '/progress/exercise/$exerciseId'
    | '/progress/skill/$skillCode'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/browse'
    | '/constructions'
    | '/history'
    | '/home'
    | '/lexicon'
    | '/login'
    | '/me'
    | '/practice'
    | '/progress'
    | '/skills'
    | '/admin/reports'
    | '/admin/users'
    | '/practice/$exerciseId'
    | '/progress/exercise/$exerciseId'
    | '/progress/skill/$skillCode'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BrowseRoute: typeof BrowseRoute
  ConstructionsRoute: typeof ConstructionsRoute
  HistoryRoute: typeof HistoryRoute
  HomeRoute: typeof HomeRoute
  LexiconRoute: typeof LexiconRoute
  LoginRoute: typeof LoginRoute
  MeRoute: typeof MeRoute
  PracticeRoute: typeof PracticeRouteWithChildren
  ProgressRoute: typeof ProgressRouteWithChildren
  SkillsRoute: typeof SkillsRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/skills': {
      id: '/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof SkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progress': {
      id: '/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof ProgressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice': {
      id: '/practice'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof PracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lexicon': {
      id: '/lexicon'
      path: '/lexicon'
      fullPath: '/lexicon'
      preLoaderRoute: typeof LexiconRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/constructions': {
      id: '/constructions'
      path: '/constructions'
      fullPath: '/constructions'
      preLoaderRoute: typeof ConstructionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse': {
      id: '/browse'
      path: '/browse'
      fullPath: '/browse'
      preLoaderRoute: typeof BrowseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice/$exerciseId': {
      id: '/practice/$exerciseId'
      path: '/$exerciseId'
      fullPath: '/practice/$exerciseId'
      preLoaderRoute: typeof PracticeExerciseIdRouteImport
      parentRoute: typeof PracticeRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progress/skill/$skillCode': {
      id: '/progress/skill/$skillCode'
      path: '/skill/$skillCode'
      fullPath: '/progress/skill/$skillCode'
      preLoaderRoute: typeof ProgressSkillSkillCodeRouteImport
      parentRoute: typeof ProgressRoute
    }
    '/progress/exercise/$exerciseId': {
      id: '/progress/exercise/$exerciseId'
      path: '/exercise/$exerciseId'
      fullPath: '/progress/exercise/$exerciseId'
      preLoaderRoute: typeof ProgressExerciseExerciseIdRouteImport
      parentRoute: typeof ProgressRoute
    }
  }
}

interface PracticeRouteChildren {
  PracticeExerciseIdRoute: typeof PracticeExerciseIdRoute
}

const PracticeRouteChildren: PracticeRouteChildren = {
  PracticeExerciseIdRoute: PracticeExerciseIdRoute,
}

const PracticeRouteWithChildren = PracticeRoute._addFileChildren(
  PracticeRouteChildren,
)

interface ProgressRouteChildren {
  ProgressExerciseExerciseIdRoute: typeof ProgressExerciseExerciseIdRoute
  ProgressSkillSkillCodeRoute: typeof ProgressSkillSkillCodeRoute
}

const ProgressRouteChildren: ProgressRouteChildren = {
  ProgressExerciseExerciseIdRoute: ProgressExerciseExerciseIdRoute,
  ProgressSkillSkillCodeRoute: ProgressSkillSkillCodeRoute,
}

const ProgressRouteWithChildren = ProgressRoute._addFileChildren(
  ProgressRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BrowseRoute: BrowseRoute,
  ConstructionsRoute: ConstructionsRoute,
  HistoryRoute: HistoryRoute,
  HomeRoute: HomeRoute,
  LexiconRoute: LexiconRoute,
  LoginRoute: LoginRoute,
  MeRoute: MeRoute,
  PracticeRoute: PracticeRouteWithChildren,
  ProgressRoute: ProgressRouteWithChildren,
  SkillsRoute: SkillsRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminUsersRoute: AdminUsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
